// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3NvnQ","colMin":"styles_colMin__mVpfW","colCheckbox":"styles_colCheckbox__312vJ"};